import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import TextArea from '../TextArea';
import {isMobileAndroid} from 'sources/webrtc/streams/browserDetector';
import MacroTextArea from 'components/controls/MacroTextAreaContainer';

export default class FormTextArea extends Component {
    static propTypes = {
        label: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func,
        withMacro: PropTypes.bool,
    };

    static defaultProps = {
        withMacro: false,
    };

    render() {
        const {
            label,
            error,
            withMacro,
            ...restProps
        } = this.props;
        const isAndroid = isMobileAndroid();

        return (
            <FormField label={label} error={error}>
                {isAndroid && withMacro
                    ? <MacroTextArea {...restProps} error={error} />
                    : <TextArea {...restProps} error={error} withMacro={withMacro && !isAndroid}/>
                }
            </FormField>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormTextArea.jsx